import React from 'react';
import { Box, Typography } from '@mui/material';
import { Note } from '../../api/homeSiteNotes/types';
import { formatDateTime } from '../../utils/functions';

interface NotesTooltipProps {
  notes: Note[];
  homeSiteId: string;
}

export const NotesTooltip: React.FC<NotesTooltipProps> = ({
  notes,
  homeSiteId
}) => {
  // Sort notes by date (newest first) and show latest 1
  const sortedNotes = [...notes]
    .sort((a, b) => {
      const dateA = new Date(a.createdOnDate).getTime();
      const dateB = new Date(b.createdOnDate).getTime();
      return dateB - dateA; // Newest first
    })
    .slice(0, 1); // Show latest 1 note

  if (!sortedNotes || sortedNotes.length === 0) {
    return (
      <Box sx={{ p: 1.5, minWidth: 250 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
          Latest Notes
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No notes available
        </Typography>
      </Box>
    );
  }

  const latestNote = sortedNotes[0];

  return (
    <Box sx={{ p: 1.5, minWidth: 280, maxWidth: 400 }}>
      <Box>
        {latestNote.mileStoneName && (
          <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#3F63C0', display: 'block', mb: 0.5 }}>
            {latestNote.mileStoneName}
          </Typography>
        )}
        <Typography variant="body2" sx={{ fontSize: '0.75rem', mb: 0.5, wordBreak: 'break-word' }}>
          {latestNote.description || 'No description'}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.5 }}>
          <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
            {latestNote.createdBy || 'Unknown'}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
            {latestNote.createdOnDate ? formatDateTime(new Date(latestNote.createdOnDate)) : ''}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
